import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import DraftDetail from './DraftDetail';
import ConfirmDialog from '../../Shared/ConfirmDialog2/ConfirmDialog';
import useDraftDetail from './hooks/useDraftDetail';
import styles from './DraftEnquiries.module.css';

const DraftDetailPage = () => {
  const { draft_id } = useParams();
  const {
    draft,
    formData,
    truckTypes,
    materialCategories,
    isLoading,
    isError,
    handleFormChange,
    handleBack,
    handleSave,
    handleAccept,
    handleReject,
  } = useDraftDetail(draft_id);

  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: '',
    message: '',
    onConfirm: () => {},
    variant: 'default',
  });

  const closeConfirm = () => setConfirmDialog((d) => ({ ...d, isOpen: false }));

  const handleAcceptWithConfirm = () =>
    setConfirmDialog({
      isOpen: true,
      title: 'Accept Enquiry',
      message: 'Accept this draft and submit it as a spot enquiry?',
      onConfirm: handleAccept,
      variant: 'default',
    });

  const handleRejectWithConfirm = () =>
    setConfirmDialog({
      isOpen: true,
      title: 'Reject Enquiry',
      message: 'Reject this draft? This cannot be undone.',
      onConfirm: handleReject,
      variant: 'danger',
    });

  if (isError) {
    return (
      <div className={styles.container}>
        <div className={styles.emptyState}>
          <i className="fa fa-exclamation-circle" style={{ fontSize: '36px', color: '#ef4444', marginBottom: '12px' }}></i>
          <p>Failed to load draft details.</p>
          <button onClick={handleBack} style={{ marginTop: '12px', cursor: 'pointer' }}>Back to Drafts</button>
        </div>
      </div>
    );
  }

  return (
    <>
      <ConfirmDialog
        isOpen={confirmDialog.isOpen}
        onClose={closeConfirm}
        onConfirm={confirmDialog.onConfirm}
        title={confirmDialog.title}
        message={confirmDialog.message}
        variant={confirmDialog.variant}
      />

      {isLoading && !draft ? (
        <div className={styles.container}>
          <div className={styles.loadingWrap}>
            <i className="fa fa-spinner fa-spin" />
          </div>
        </div>
      ) : draft && formData ? (
        <div className={styles.container}>
          <DraftDetail
            draft={draft}
            formData={formData}
            onChange={handleFormChange}
            onBack={handleBack}
            onSave={handleSave}
            onAccept={handleAcceptWithConfirm}
            onReject={handleRejectWithConfirm}
            truckOptions={truckTypes}
            productOptions={materialCategories}
          />
        </div>
      ) : null}
    </>
  );
};

export default DraftDetailPage;
